export default x => () => x;



//////////////////
// WEBPACK FOOTER
// ./~/d3-zoom/src/constant.js
// module id = 748
// module chunks = 0